import { createContext, type FunctionComponent, type PropsWithChildren, useContext } from 'react';

import type { UiActionBlock } from '../data-contract/chat';
import type { AgentUiPathResolver } from './auto-run';
import { UiActionAutoRun } from './UiActionAutoRun';

const AgentUiPathContext = createContext<AgentUiPathResolver | null>(null);

type AgentUiProviderProps = PropsWithChildren<{
    readonly autoRunOrigins: readonly string[];
    readonly resolvePath: AgentUiPathResolver;
}>;

export const AgentUiProvider: FunctionComponent<AgentUiProviderProps> = ({ autoRunOrigins, children, resolvePath }) => (
    <AgentUiPathContext.Provider value={resolvePath}>
        {children}
        <UiActionAutoRun autoRunOrigins={autoRunOrigins} resolvePath={resolvePath} />
    </AgentUiPathContext.Provider>
);

export const useAgentUiPath = (block: UiActionBlock): string | undefined => useContext(AgentUiPathContext)?.(block);
